<template>
  <!-- CONTENT -->
  <div class="page-layout__inner  exam">

    <div class="page-layout__content">

      <section class="tabs-3">

        <ul class="nav  tabs-3__nav  tabs-3__hor-nav">

          <li v-if="hasPermission('api.application.profile.candidates') && application.type && application.type.id !== APP_TYPE_DEMO" class="tabs-3__nav-item">
            <a class="tabs-3__nav-link" @click="tabSelect('candidates')" :class="{'active' : tabs.candidates}" data-toggle="tab" href="javascript:void(0)">{{ getTranslation('candidates') }}</a>
          </li>

          <li v-if="hasPermission('api.application.get') && hasPermission('api.application.profile.setStructure')" class="tabs-3__nav-item">
            <a class="tabs-3__nav-link" @click="tabSelect('testing')" data-toggle="tab" :class="{'active' : tabs.testing}" href="javascript:void(0)">{{ getTranslation('aboutTesting') }}</a>
          </li>

          <li v-if="hasPermission('api.application.profile.testingEvents')" class="tabs-3__nav-item">
            <a class="tabs-3__nav-link" @click="tabSelect('events')" data-toggle="tab" :class="{'active' : tabs.events}" href="javascript:void(0)">{{ getTranslation('testingEvents') }}</a>
          </li>

          <li v-if="hasPermission('api.application.profile.position')" class="tabs-3__nav-item">
            <a class="tabs-3__nav-link" @click="tabSelect('position')" data-toggle="tab" :class="{'active' : tabs.position}" href="javascript:void(0)">{{ getTranslation('aboutPosition') }}</a>
          </li>

          <li v-if="hasPermission('api.application.profile.logins')" class="tabs-3__nav-item">
            <a class="tabs-3__nav-link" @click="tabSelect('logins')" :class="{'active' : tabs.logins}" data-toggle="tab" href="javascript:void(0)">{{ getTranslation('loginHistory') }}</a>
          </li>

          <li v-if="hasPermission('api.application.profile.results') && application.status !== 'REJECTED'" class="tabs-3__nav-item">
            <a class="tabs-3__nav-link" @click="tabSelect('results')" :class="{'active' : tabs.results}" data-toggle="tab" href="javascript:void(0)">{{ getTranslation('results') }}</a>
          </li>

        </ul>


        <div class="tabs-3__content  tabs-3__content--p-0">

          <!-- CANDIDATES TAB -->
          <div v-if="hasPermission('api.application.profile.candidates') && application.type && application.type.id !== APP_TYPE_DEMO" class="tabs-3__pane" :class="{'active': tabs.candidates}">

            <CandidatesComponent :active="tabs.candidates" :app-id="$route.params.id" :app="application"/>

          </div>
          <!-- / CANDIDATES TAB -->

          <!-- Testing EVENT TAB -->
          <div v-if="hasPermission('api.application.profile.testingEvents')" class="tabs-3__pane" :class="{'active': tabs.events}">

            <EventsComponent v-if="!calendarView" :app="application" :active="tabs.events" :app-id="$route.params.id"/>

            <CalendarComponent
                v-if="calendarView"
                :subject-id="$route.params.id"
                :subject-type="'application'"
                :testing-interval="application.eventInterval"
                :calendar-options="{
                                    defaultView: 'dayGridMonth',
                                    header: {
                                        left: 'prevYear,prev,next,nextYear, today',
                                        center: 'title',
                                        right: 'dayGridMonth,timeGridWeek,timeGridDay'
                                    },
                                    businessHours:false,
                                    eventCreate:false,
                                    calendarWeekends: true,
                                    tableView: true,
                                    allDayDefault: false,
                                    editable: false,
                                    eventOverlap: true,
                                    displayEventEnd: true,
                                    droppable: false,
                                    windowResizeDelay: 100,
                                    eventBackgroundColor:'#d7f0f7'
                         }"
                :active="calendarView"
            />

          </div>
          <!-- / Testing EVENT TAB -->

          <!-- ABOUT TEST TAB -->
          <div v-if="hasPermission('api.application.get') && hasPermission('api.application.profile.setStructure')" class="tabs-3__pane" :class="{'active': tabs.testing}">
            <ApplicationStructureComponent :app-id="$route.params.id" :app="application"/>
          </div>
          <!-- / ABOUT TEST TAB -->

          <!-- POSITION TAB -->
          <div v-if="hasPermission('api.application.profile.position')" class="tabs-3__pane" :class="{'active': tabs.position}">
            <AppPositionComponent :application="application" :active="tabs.position"/>
          </div>

          <!-- logins TAB -->
          <div v-if="hasPermission('api.application.profile.logins')" class="tabs-3__pane" :class="{'active': tabs.logins}">

            <table class="table  table--noborder">
              <AppLoginsComponent :active="tabs.logins" :app-id="$route.params.id"/>
            </table>
            <!-- /.table -->

          </div>
          <!-- / logins TAB -->

          <!-- RESULTS TAB -->
          <div v-if="hasPermission('api.application.profile.results') && application.status !== 'REJECTED'" class="tabs-3__pane" :class="{'active': tabs.results}">

            <table class="table  table--noborder">
              <ResultsComponent @updateApp="fetchApplication($route.params.id)" :active="tabs.results" :app-id="$route.params.id" :app="application"/>
            </table>
            <!-- /.table -->

          </div>
          <!-- / RESULTS TAB -->

        </div>
        <!-- /tabs-3__content -->

      </section>
      <!-- /.tabs-3 -->

    </div>
    <!-- /.page-layout__content -->


    <div class="page-layout__info-sidebar">

      <div class="exam__data">
        <h3>{{ getTranslation('aboutApplication') }}</h3>
        <div class="exam__data-group">
          <div class="exam__data-label">{{ getTranslation('creationType') }}</div>
          <div class="exam__data-value">
            <span class="badge badge--warning" v-if="application.fromNrk">{{ getTranslation('appFromNrk') }}</span>
            <span class="badge badge--warning" v-else>{{ getTranslation('appFromManual') }}</span>
          </div>
        </div>
        <div v-if="application.contestType" class="exam__data-group">
          <div class="exam__data-label">{{ getTranslation('contestType') }}</div>
          <div class="exam__data-value">{{ getTranslation(application.contestType.title) }}</div>
        </div>
        <div class="exam__data-group">
          <div class="exam__data-label">{{ getTranslation('type') }}</div>
          <div class="exam__data-value"><span v-if="application.type">{{ application.type.title }}</span></div>
        </div>
        <div class="exam__data-group">
          <div class="exam__data-label">{{ getTranslation('resource') }}</div>
          <div class="exam__data-value">
            <span v-if="application.resource">{{ application.resource.resourceType.title }}</span></div>
        </div>
        <div v-if="application.resource" class="exam__data-group">
          <div v-if="application.resource.resourceType.id === RESOURCE_LOCAL_POSITIONS_ID" class="exam__data-group">
            <div class="exam__data-group">
              <div class="exam__data-label">{{ getTranslation('state') }}</div>
              <div class="exam__data-value">
                {{ application.resource.stateName }}
              </div>
            </div>
            <div class="exam__data-group">
              <div class="exam__data-label">{{ getTranslation('position') }}</div>
              <div class="exam__data-value">
                {{ application.resource.positionName }}
              </div>
            </div>
          </div>
          <div v-if="application.resource.resourceType.id === RESOURCE_EKYZMAT_ID" class="exam__data-group">
            <div class="exam__data-group">
              <div class="exam__data-label">{{ getTranslation('position') }}</div>
              <div class="exam__data-value">
                {{ application.resource.positionName }}
              </div>
            </div>

          </div>
          <div v-if="application.resource.resourceType.id === RESOURCE_NRK_ID" class="exam__data-group">

            <div class="exam__data-group">
              <div class="exam__data-label">{{ getTranslation('title') }}</div>
              <div class="exam__data-value">
                {{ application.resource.title }}
              </div>
            </div>
            <div class="exam__data-group">
              <div class="exam__data-label">{{ getTranslation('category') }}</div>
              <div class="exam__data-value">
                {{ application.resource.resourceTitle }}
              </div>
            </div>
          </div>
        </div>
        <div class="exam__data-group mt-3">
          <div v-if="application.user" class="exam__data-group">
            <div class="exam__data-label">
              {{ getTranslation('whoCreatedApp') }}
            </div>
            <div class="exam__data-value">
              <router-link v-if="hasUserViewPermission(application.user.id)" :to="{name:'api.users.get',params:{id:application.user.id}}">
                {{ application.user.fullName }}
              </router-link>
              <span v-else>{{ application.user.fullName }}</span>
            </div>
          </div>
        </div>
        <div class="exam__data-group">
          <div class="exam__data-label"> {{ getTranslation('dateOfCreation') }}</div>
          <div class="exam__data-value">{{ momentFormatDate(application.creationDate, 'HH:mm DD.MM.YYYY') }}</div>
        </div>
        <div v-if="application.status==='CONFIRMED'" class="exam__data-group mt-3">
          <div class="exam__data-group">
            <div class="exam__data-label">
              {{ getTranslation('whoConfirmed') }}
            </div>
            <div class="exam__data-value">
              <router-link v-if="hasUserViewPermission(application.modifiedUser.id)" :to="{name:'api.users.get',params:{id:application.modifiedUser.id}}">
                {{ application.modifiedUser.fullName }}
              </router-link>
              <span v-else>{{ application.modifiedUser.fullName }}</span></div>
          </div>

          <div class="exam__data-group">
            <div class="exam__data-label"> {{ getTranslation('confirmedDate') }}</div>
            <div class="exam__data-value">{{ momentFormatDate(application.modifiedDate, 'HH:mm DD.MM.YYYY') }}</div>
          </div>
        </div>
        <div v-if="application.status==='REJECTED'" class="exam__data-group mt-3">
          <div class="exam__data-group">
            <div class="exam__data-label">
              {{ getTranslation('whoRejected') }}
            </div>
            <div class="exam__data-value">
              <router-link v-if="hasUserViewPermission(application.modifiedUser.id)" :to="{name:'api.users.get',params:{id:application.modifiedUser.id}}">
                {{ application.modifiedUser.fullName }}
              </router-link>
              <span v-else>{{ application.modifiedUser.fullName }}</span></div>
          </div>
          <div class="exam__data-group">
            <div class="exam__data-label">{{ getTranslation('rejectedDate') }}</div>
            <div class="exam__data-value">{{ momentFormatDate(application.modifiedDate, 'HH:mm DD.MM.YYYY') }}</div>
          </div>
        </div>
      </div>

    </div>
    <!-- /.page-layout__info-sidebar -->

  </div>
  <!-- / CONTENT -->
</template>

<script>
import applicationMixin from "./mixins/application";
import CandidatesComponent from "./components/CandidatesComponent";
import EventsComponent from "./components/EventsComponent";
import ApplicationStructureComponent from "./components/ApplicationStructureComponent";
import ResultsComponent from "./components/ResultsComponent";
import CalendarComponent from "../../../components/CalendarComponent";
import AppPositionComponent from "./components/PositionComponent";
import AppLoginsComponent from "./components/AppLoginsComponent";

export default {
  name: "ViewApplication",
  components: {
    AppLoginsComponent,
    AppPositionComponent,
    CalendarComponent,
    ResultsComponent,
    ApplicationStructureComponent,
    EventsComponent,
    CandidatesComponent
  },
  mixins: [applicationMixin],
  data() {
    return {
      calendarView: false,
      tabs: {
        candidates: false,
        testing: false,
        position: false,
        results: false,
        events: false,
        logins: false,
        comment: false,
      },
      comment: {value: ''},
    }
  },
  mounted() {
    this.$root.$on('toggleCalendar', () => {
      this.calendarView = !this.calendarView;
    });

    this.$root.$on('eventReject', () => {
      this.fetchApplication(this.$route.params.id);
    });
  },
  created() {
    this.fetchApplication(this.$route.params.id).then(() => {
      this.updateHeadings();
    });
    this.tabSelect(this.$route.query.tab,'testing');
  },
  beforeDestroy() {
    this.$store.dispatch('heading/resetAppInfo');
  },
  methods: {
    toggleCalendar() {
      this.calendarView = !this.calendarView;
    },
    updateHeadings() {
      let actions = [];
      if (this.application.status === 'NEW' && this.hasPermission('api.application.profile.reject'))
        actions.push({
          label: this.getTranslation('deny'),
          icon: {
            icon: '#icon__square-cross',
            classes: 'btn__icon--danger'
          },
          action: this.denyApp
        });
      if (this.application.status === 'NEW' && this.hasPermission('api.application.profile.confirm'))
        actions.push({
          label: this.getTranslation('accept'),
          icon: {
            icon: '#icon__square-check',
            classes: 'btn__icon--success'
          },
          action: this.confirmApp
        });

      this.setHeadings({
        title: this.application.title,
        breadcrumbs: [
          {
            label: this.getTranslation('applications'),
            route: {name: 'api.application.getList'}
          },
          {
            label: this.application.title,
          }
        ],
        actions: actions,
        toBack: {
          label: this.getTranslation('backToApplicationList'),
          route: {name: 'api.application.getList'}
        }
      });

      this.setAppInfo(this.application);
    },

    setAppInfo(app) {
      let appInfo = {};
      appInfo.id = app.id;
      appInfo.status = app.status;
      appInfo.isTrial = app.isTrial;

      if (app.status === 'REJECTED') {
        appInfo.isRejected = true;
        appInfo.comment = app.comment;
      }

      if (app.nrkOffice) {
        appInfo.office = app.nrkOffice.title;
        appInfo.officeId = app.nrkOffice.id;
      }

      if (app.nrkDate)
        appInfo.date = this.momentFormatDate(app.nrkDate, 'DD.MM.YYYY, HH:mm');

      this.$store.dispatch('heading/setAppInfo', appInfo);
    },

    confirmApp() {
      Swal.fire({
        title: this.getTranslation('areYouSure'),
        text: this.getTranslation('cantRevertMsg'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.getTranslation('cancel'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.getTranslation('ImSure')
      }).then((result) => {
        if (result.value) {
          this.confirmApplication(this.$route.params.id).then(response => {

            if (response.data.data.modalTitle) {
              Swal.fire({
                icon: 'warning',
                title: this.getTranslation(response.data.data.modalTitle),
                text: this.getTranslation(response.data.data.modalText)
              })
            } else {
              Swal.fire(
                  this.getTranslation('confirmed'),
                  this.getTranslation('appConfirmedMsg'),
                  'success'
              );
            }

            this.fetchApplication(this.$route.params.id).then(() => {
              this.updateHeadings();
            });
          }).catch(()=>{});
        }
      })
    },
    async denyApp() {
      this.comment = await Swal.fire({
        title: '<label class="form__label reject--comment-label">' + this.getTranslation('rejectComment') + '<span class="required">*</span></label>',
        input: 'textarea',
        inputPlaceholder: this.getTranslation('writeRejectComment'),
        inputValidator: (value) => {
          if (!value) {
            return this.getTranslation('writeRejectComment');
          }
        },
        showCancelButton: true,
        cancelButtonText: this.getTranslation('cancel')
      });

      if (this.comment.value) {
        this.rejectApplication(this.$route.params.id, {comment: this.comment.value}).then(() => {
          this.fetchApplication(this.$route.params.id).then(() => {
            this.updateHeadings();
          });
        }).catch(() => {
        });
      }
    }
  },
}
</script>

<style scoped>

</style>
